//Get reducer from store
export const getUser = (state) => state.userReducer;
export const getMessages = (state) => state.messagesReducer;
export const getAppointments = (state) => state.appointmentsReducer;
export const getProfile = (state) => state.profilesReducer.profile;
export const getNativeWebView = (state) => state.commonReducer.nativeWebView;